// import { useSelector } from "react-redux"

import Button from "components/ui/button"
import { IS_NA, IS_CA, IS_US, IS_INT, isTestMode } from "helpers/application"
import useWindowDimensions from "helpers/window-dimensions"

export const usePopupTrigger = () => {
  const { isMobile } = useWindowDimensions()

  return () => {
    try {
      if (IS_NA()) {
        const attentiveBoxID = isMobile
          ? IS_US()
            ? 1279623 // US Mobile
            : 1279620 // CA Mobile
          : IS_US()
            ? 1279624 // US Desktop
            : 1279622 // CA Desktop
        window.__attentive.trigger(null, null, null, attentiveBoxID)
      } else if (IS_INT()) {
        const globaleBoxID = "62fe0068-9e80-43c7-9d70-1a1b763cf156" // global e 319668
        window.DIGIOH_API.LIGHTBOX.loadLightbox(globaleBoxID)
      } else {
        const lightboxID = "174622d6-5a14-4aad-81fb-af58bfcb0451" // 319620
        console.log("Popup trigger", lightboxID)
        window.DIGIOH_API.LIGHTBOX.loadLightbox(lightboxID)
      }
    } catch (err) {
      console.log("Error loading popup: ", err)
    }
  }
}

const FooterSubscribe = () => {
  // const microbannerExp = useSelector(
  //   (state) => state.experiment.microbanner.variant_id
  // )
  const showSpinToWin = !IS_CA()

  // const triggerPopup = usePopupTrigger(microbannerExp)
  const triggerPopup = usePopupTrigger()

  return (
    <div className="bg-primary text-white">
      <div className="tablet:items-center tablet:gap-48 contained-wide tablet:flex-row widescreen:px-60 widescreen:py-60 tablet:px-32 flex flex-col items-start justify-between px-16 py-32">
        <h2 className="display-md leading-72 desktop:leading-none tablet:mb-0 mb-24 shrink-0 whitespace-nowrap font-bold">
          Stay
          <wbr /> in touch
        </h2>
        <div className="tablet:w-auto tablet:items-end xlarge:items-center xlarge:flex-row flex w-full flex-col items-start">
          <p className="xlarge:mr-64 tablet:text-right body-lg desktop:font-semibold desktop:leading-none tablet:mb-8 xlarge:mb-0 mb-24 whitespace-nowrap font-normal">
            {IS_INT() ? (
              <>
                Subscribe to our emails
                <wbr /> and save an extra 15%
              </>
            ) : showSpinToWin ? (
              <>
                Subscribe to our emails
                <wbr /> and spin to win
              </>
            ) : (
              <>
                Subscribe to our emails
                <wbr /> and save an extra 15%
              </>
            )}
          </p>
          <Button
            className="tablet:w-(--tablet-width) outline-black-print widescreen:w-(--widescreen-width) w-full uppercase"
            onClick={() => {
              if (!isTestMode) {
                dataLayer.push({ event: "trigger-footer-sign-up-unit" })
              }

              triggerPopup()
            }}
            style={{
              "--tablet-width": "230px",
              "--widescreen-width": "300px",
            }}
            variant="primary"
          >
            {/* {showSpinToWin ? "Get your code" : "Sign up now"} */}
            Get your code
          </Button>
        </div>
      </div>
    </div>
  )
}

export default FooterSubscribe
